import { render, staticRenderFns } from "./OAuthRedirectShow.vue?vue&type=template&id=d968c392"
import script from "./OAuthRedirectShow.vue?vue&type=script&lang=js"
export * from "./OAuthRedirectShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports